import { render, staticRenderFns } from "./splitScreen.vue?vue&type=template&id=2e81ac16"
import script from "./splitScreen.vue?vue&type=script&lang=js"
export * from "./splitScreen.vue?vue&type=script&lang=js"
import style0 from "./splitScreen.vue?vue&type=style&index=0&id=2e81ac16&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports